/**
 * Report Studio - My Reports page.
 * Lists user's reports with search and CRUD actions.
 */

import { createFileRoute } from '@tanstack/react-router';

import { ReportList, ReportStudioShell } from '@/features/analytics/report-studio';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/analytics/report-studio/')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.reportStudio'),
  }),
  component: ReportStudioIndexPage,
});

function ReportStudioIndexPage() {
  return (
    <ReportStudioShell>
      <ReportList />
    </ReportStudioShell>
  );
}
